import type { DriverEntity } from '@/features/driver/domain/entities/DriverEntity'
import type { RegionEntity } from '@/features/region/domain/entities/RegionEntity'
import type { UserMiniEntity } from '@/features/user/domain/entities/UserMiniEntity'
import type { PouchOperationType } from '../enums/PouchOperationType'

export class PouchFilterEntity {
  driver?: DriverEntity
  region?: RegionEntity
  driverHalted?: boolean
  user?: UserMiniEntity
  transactionStartDate?: string
  transactionEndDate?: string
  page?: number
  limit?: number
  isDriverBlocked?: boolean
  pouchOperationsType?: PouchOperationType
}
